import { call, put, takeEvery } from 'redux-saga/effects';
import { conversationFormActions } from '../actions/conversationForm';
import * as conversationFormAPI from '../api/conversationForm';
const { conversationFormAddAttachments, conversationFormAddAttachmentsSucceeded, conversationFormAddAttachmentsFailed, } = conversationFormActions;
export const conversationForm = [
    takeEvery(conversationFormAddAttachments.toString(), genWithPromise(conversationFormAPI.upload, conversationFormAddAttachmentsSucceeded, conversationFormAddAttachmentsFailed)),
];
function genWithPromise(apiAction, resultSucceededAction, resultFailedAction) {
    return function* (action) {
        let result;
        try {
            result = yield call(apiAction, action.payload);
            yield call(action.meta.resolve, result);
            yield put(resultSucceededAction(result));
        }
        catch (exception) {
            console.warn(exception);
            // Something went wrong. We reject the promise.
            yield call(action.meta.reject, exception);
            result = exception;
            yield put(resultFailedAction(result));
        }
    };
}
